import SurveysService from 'src/services/surveys'
import { v4 as uuidv4 } from 'uuid'

export default {
  createSurvey (payload) {
    return SurveysService.newSurvey(payload)
  },
  async fetchSurveys () {
    const data = await SurveysService.fetchSurveys()
    this.surveys = data
    return data
  },
  deleteSurvey (id) {
    return SurveysService.deleteSurvey(id)
  },
  async showSurvey (id) {
    const data = await SurveysService.showSurvey(id)
    this.survey = data
    this.publishedStatus = data.is_published
    return data
  },
  async updateSurvey (payload) {
    const data = await SurveysService.updateSurvey(payload)
    this.survey = data
    return data
  },
  surveyIsPublished (payload) {
    return SurveysService.surveyIsPublished(payload)
  },
  surveyIsArchived (payload) {
    return SurveysService.surveyIsArchived(payload)
  },
  surveyCloning (payload) {
    return SurveysService.surveyCloning(payload)
  },
  resetSurvey () {
    this.survey = null
  },
  createItems (payload) {
    return SurveysService.createItems(payload)
  },
  async fetchItems (id) {
    const data = await SurveysService.fetchItems(id)
    this.items = (data.items || data).sort((a, b) => a.order - b.order)
    this.sections = (data.sections || []).sort((a, b) => a.order - b.order)
    return data
  },
  async fetchItemsPreview (id) {
    const data = await SurveysService.fetchItemsPreview(id)
    this.items = data.items || data
    this.sections = data.sections || []
    return data
  },
  async fetchItemsPublic (id) {
    const data = await SurveysService.fetchItemsPublic(id)
    this.items = data.items || data
    this.sections = data.sections || []
    return data
  },
  async fetchConfigSurvey (id) {
    const data = await SurveysService.fetchConfigSurvey(id)
    this.config = data
    return data
  },
  async surveyBytoken (token) {
    const data = await SurveysService.surveyBytoken(token)
    this.survey = data
    return data
  },
  saveSurveyOccurrence (payload) {
    return SurveysService.saveSurveyOccurrence(payload)
  },
  resetItems (payload) {
    this.items = payload
    this.sections = []
  },
  restoreItems (snapshot) {
    this.items = JSON.parse(JSON.stringify(snapshot.items))
    this.sections = JSON.parse(JSON.stringify(snapshot.sections))
  },
  async fetchLocationsSurvey (id) {
    const data = await SurveysService.fetchLocationsSurveyOrganization(id)
    this.locations = data
    return data
  },

  /* ===== ITEMS ===== */
  addNewItem (index = null) {
    const newIndex = index === null ? this.items.length : index
    const newItem = {
      temp_id: uuidv4(),
      id: null,
      name: '',
      description: '',
      type: 'form-option',
      placeholder: null,
      value: 1,
      order: newIndex,
      require: false,
      options: [
        { option: '', value: 1 },
        { option: '', value: 2 },
        { option: '', value: 3 }
      ],
      visibility_rules: [],
      jump_rules: []
    }

    if (index === null) this.items.push(newItem)
    else this.items.splice(index, 0, newItem)
  },
  cloneItem (index) {
    if (index < 0 || index >= this.items.length) return

    const sourceItem = this.items[index]
    const clonedItem = JSON.parse(JSON.stringify(sourceItem))

    clonedItem.id = null
    clonedItem.temp_id = uuidv4()
    clonedItem.require = clonedItem.required

    delete clonedItem.updated_at
    delete clonedItem.created_at
    delete clonedItem.required
    delete clonedItem.survey_id
    delete clonedItem.survey_organization_id

    const newOrder = sourceItem.order + 1
    clonedItem.order = newOrder

    if (sourceItem.section_id == null) {
      this.sections = this.sections.map(s =>
        s.order >= newOrder ? { ...s, order: s.order + 1 } : s
      )
      this.items = this.items.map(i =>
        i.section_id == null && i.order >= newOrder
          ? { ...i, order: i.order + 1 }
          : i
      )
    } else {
      this.items = this.items.map(i =>
        i.section_id === sourceItem.section_id && i.order >= newOrder
          ? { ...i, order: i.order + 1 }
          : i
      )
    }

    this.items.splice(index + 1, 0, clonedItem)
  },
  setDeleteItem ({ id, temp_id }) {
    const shouldDelete = (item) =>
      (id && item.id === id) || (!id && item.temp_id === temp_id)

    this.items = this.items.filter(item => !shouldDelete(item))
  },

  /* ===== CARD ITEMS ===== */
  putOneElementInCardItems ({ changes, index }) {
    const existing = this.items[index]
    const preserved = existing
      ? { ...changes, order: existing.order, section_id: existing.section_id }
      : changes
    this.items.splice(index, 1, preserved)
  },
  updateCardOrder (newOrder) {
    this.items = newOrder
  },
  updateSectionOrder (newSections) {
    this.sections = newSections
  },

  /* ===== SECTIONS ===== */
  addNewItemInSection (sectionKey, insertOrder = null) {
    const sectionItems = this.items.filter(i => i.section_id === sectionKey)
    const newOrder = insertOrder == null ? sectionItems.length : insertOrder
    if (insertOrder != null) {
      this.items = this.items.map(i =>
        i.section_id === sectionKey && i.order >= newOrder
          ? { ...i, order: i.order + 1 }
          : i
      )
    }
    const newItem = {
      temp_id: uuidv4(),
      id: null,
      name: '',
      description: '',
      type: 'form-option',
      placeholder: null,
      value: 1,
      order: newOrder,
      require: false,
      options: [
        { option: '', value: 1 },
        { option: '', value: 2 },
        { option: '', value: 3 }
      ],
      visibility_rules: [],
      jump_rules: [],
      section_id: sectionKey
    }
    this.items.push(newItem)
  },
  addNewSection (globalOrder) {
    const newSection = {
      temp_id: uuidv4(),
      id: null,
      name: '',
      description: '',
      image_url: null,
      order: globalOrder
    }
    this.sections.push(newSection)
    // Shift all top-level elements that had order >= globalOrder (except the new one)
    this.sections = this.sections.map(s =>
      s.temp_id !== newSection.temp_id && s.order >= globalOrder
        ? { ...s, order: s.order + 1 }
        : s
    )
    this.items = this.items.map(i =>
      i.section_id == null && i.order >= globalOrder
        ? { ...i, order: i.order + 1 }
        : i
    )
  },
  cloneSection (index) {
    const source = this.sections[index]
    if (!source) return
    const cloned = JSON.parse(JSON.stringify(source))
    cloned.id = null
    cloned.temp_id = uuidv4()
    delete cloned.updated_at
    delete cloned.created_at
    delete cloned.survey_id
    delete cloned.survey_organization_id

    const newOrder = source.order + 1
    cloned.order = newOrder

    // Shift sections and root items with order >= newOrder
    this.sections = this.sections.map(s =>
      s.order >= newOrder ? { ...s, order: s.order + 1 } : s
    )
    this.items = this.items.map(i =>
      i.section_id == null && i.order >= newOrder
        ? { ...i, order: i.order + 1 }
        : i
    )
    this.sections.push(cloned)
  },
  deleteSection ({ id, temp_id }) {
    const match = s => (id && s.id === id) || (!id && s.temp_id === temp_id)
    const section = this.sections.find(match)
    if (!section) return
    // Remove items that belonged to this section
    const sectionKey = section.id || section.temp_id
    this.items = this.items.filter(i => i.section_id !== sectionKey)
    this.sections = this.sections.filter(s => !match(s))
    // Clean up dangling jump rules on surviving items that pointed to the
    // deleted section as a jump target; otherwise navigation breaks silently.
    this.items = this.items.map(item => {
      if (!Array.isArray(item.jump_rules)) return item
      const hasDangling = item.jump_rules.some(
        r => r.action === 'section' && r.target_section_id === sectionKey
      )
      if (!hasDangling) return item
      return {
        ...item,
        jump_rules: item.jump_rules.map(r =>
          r.action === 'section' && r.target_section_id === sectionKey
            ? { ...r, action: 'next', target_section_id: null }
            : r
        )
      }
    })
  },
  putOneElementInSections ({ changes, index }) {
    this.sections.splice(index, 1, changes)
  }
}
